import {
  BookingRequestsFiltersState,
  BookingRequestsListParameters,
} from '../../app/components/BookingRequestsFilters';
import { useSearchParamsState } from '../../app/hooks/search-params';

export const useBookingRequestsFilters = () => {
  const [specialties, setSpecialties] = useSearchParamsState('specialties', [], true);
  const [healthcareFacility, setFacilities] = useSearchParamsState<
    BookingRequestsListParameters['healthcareFacility']
  >('healthcareFacility', [], true);
  const [sortBy, setSortBy] = useSearchParamsState<BookingRequestsListParameters['sortBy']>(
    'sort_by',
    'first_shift'
  );
  const [sortDirection, setSortDirection] = useSearchParamsState<
    BookingRequestsListParameters['sortDirection']
  >('sort_direction', 'asc');

  const [shiftDate, setShiftDate] = useSearchParamsState<
    [BookingRequestsListParameters['dateFrom'], BookingRequestsListParameters['dateTo']]
  >('shift_date', ['', ''], true);
  const [search, setSearch] = useSearchParamsState<BookingRequestsListParameters['search']>(
    'search',
    ''
  );

  const setFilters = (filters: BookingRequestsFiltersState) => {
    setSpecialties(filters.specialties);
    setFacilities(filters.healthcareFacility);
    setSortBy(filters.sortBy);
    setSortDirection(filters.sortDirection);
    setShiftDate(filters.shiftDate);
    setSearch(filters.search);
  };

  return {
    filters: {
      specialties,
      healthcareFacility,
      sortBy,
      sortDirection,
      shiftDate,
      search,
    },
    setFilters,
  };
};
